import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  showArrow?: boolean;
  className?: string;
}
export function PrimaryButton({
  children,
  onClick,
  href,
  size = 'lg',
  fullWidth = false,
  showArrow = true,
  className = ''
}: PrimaryButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  const sharedClassName = `group inline-flex items-center justify-center gap-2 ${sizeClasses} ${fullWidth ? 'w-full' : ''} rounded-xl bg-orange font-heading font-semibold uppercase tracking-wide text-white transition-all duration-200 hover:bg-orange-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-orange focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary ${className}`;
  const content = <>
      {children}
      {showArrow && <ArrowRightIcon size={size === 'lg' ? 20 : 18} className="transition-transform duration-200 group-hover:translate-x-1" data-id="element-324" data-mp="gqnhy46yvdkh" />}
    </>;
  if (href) {
    return <a href={href} className={sharedClassName} data-id="element-325" data-mp="prd6qnxt83op">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={sharedClassName} data-id="element-326" data-mp="lrum7t9whume">
      {content}
    </button>;
}